let lastFullscreenElement: Element;
let isFullscreenEnabled = false;

function exitFullscreen() {
    // @ts-ignore
    const isFullscreenOn = document.fullscreenElement ||
        // @ts-ignore
        document.mozFullScreenElement ||
        // @ts-ignore
        document.webkitFullscreenElement;

    if (!isFullscreenOn) {
        return;
    }

    // eslint-disable-next-line no-unused-expressions
    document?.exitFullscreen?.();
    /* @ts-ignore */
    // eslint-disable-next-line no-unused-expressions
    document?.mozCancelFullScreen?.();
    /* @ts-ignore */
    // eslint-disable-next-line no-unused-expressions
    document?.webkitCancelFullScreen?.();
    /* @ts-ignore */
    // eslint-disable-next-line no-unused-expressions
    document?.webkitExitFullscreen?.();
}

function requestFullscreen(element: Element) {
    // eslint-disable-next-line no-unused-expressions
    element?.requestFullscreen?.();
    /* @ts-ignore  */
    // eslint-disable-next-line no-unused-expressions
    element?.mozRequestFullScreen?.();
    /* @ts-ignore */
    // eslint-disable-next-line no-unused-expressions
    element?.webkitRequestFullscreen?.();
}

export function disableFullscreenIfEnabled() {
    try {
        isFullscreenEnabled = document?.fullscreenEnabled ||
            /* @ts-ignore */
            document?.webkitFullscreenEnabled;
        if (isFullscreenEnabled) {
            /* @ts-ignore */
            lastFullscreenElement = document?.fullscreenElement ||
                /* @ts-ignore */
                document?.webkitCurrentFullScreenElement ||
                /* @ts-ignore */
                document?.webkitFullscreenElement;
            exitFullscreen();
        }
    } catch (error) {
        // eslint-disable-next-line no-alert
        alert(error);
        window.Sentry.captureException(error);
    }
}

export function reenableFullscreenIfWasEnabled() {
    try {
        if (isFullscreenEnabled) {
            requestFullscreen(lastFullscreenElement);
            isFullscreenEnabled = false;
            lastFullscreenElement = null;
        }
    } catch (error) {
        window.Sentry.captureException(error);
    }
}
